<template>
  <div class="content-430">
    <div class="class-form-head">其他设置</div>
    <div class="class-form-content">
      <Form
        ref="otherSettingInfo"
        :model="otherSettingInfo"
        label-position="right"
        :label-width="120"
        :rules="otherSettingInfoRule"
        @on-validate="getFormValidate"
      >
        <FormItem label="列表可见" prop="visibleType">
          <RadioGroup v-model="otherSettingInfo.visibleType">
            <Radio :label="1">可见</Radio>
            <!-- <Radio :label="2">仅圈定范围可见</Radio> -->
            <Radio :label="0">不可见</Radio>
          </RadioGroup>
          <div>若设置不可见，则在家长端选课列表中不展示本课程</div>
        </FormItem>
        <FormItem label="发布后上架" prop="classroomState">
          <RadioGroup v-model="otherSettingInfo.classroomState">
            <Radio :disabled="portOrg === 3 ? true : false" :label="4"
              >上架</Radio
            >
            <Radio :label="0">下架</Radio>
          </RadioGroup>
          <div>
            课程商品下架后，家长端<span class="color-red">不可见</span> 且
            课程商品<span class="color-red">不再支持</span>任何渠道下单订购！
          </div>
        </FormItem>
        <FormItem label="结算分账规则" prop="itemId">
          <div
            v-if="!courseTypeKind"
            class="ivu-input class-form-item"
            @click="hanldCourse"
          ></div>
          <Select
            v-else
            v-model="otherSettingInfo.itemId"
            class="class-form-item"
            :disabled="exsitOrder"
          >
            <Option
              v-for="item in billStsList"
              :key="item.itemId"
              :value="item.itemId"
              >{{ item.itemName }}</Option
            >
          </Select>
          <div>
            选择结算分账规则后，课程价格将按分账规则进行清分结算。请在发布商品时务必先设置好对应分账规则。商品一旦被下单后，则
            不允许修改分账规则。
          </div>
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
import common from '@/request/common/index.js';
export default {
  inject: ['AddCommodityInstance'],
  props: {
    courseId: {
      type: String,
      default: ''
    },
    schoolId: {
      type: String,
      default: ''
    },
    courseTypeKind: {
      type: String,
      default: ''
    },
    courseOrgId: {
      type: String,
      default: ''
    },

    exsitOrder: {
      type: Boolean,
      default: false
    }, // 商品是否已被购买，是否存在订单
    value: {
      type: Object,
      default: () => {
        return {
          visibleType: 1, // 列表可见范围：0：不可见 1：可见 2：指定范围可见(courseClassExtAddRO)
          classroomState: 0, //
          itemId: ''
        };
      }
    }, // v-model的值
    validatePass: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      otherSettingInfoRule: {
        classroomState: [
          {
            required: true,
            message: '请选择发布后是否上架',
            type: 'number',
            trigger: 'change'
          }
        ],
        visibleType: [
          {
            required: true,
            message: '请选择是否列表可见',
            type: 'number',
            trigger: 'change'
          }
        ],

        itemId: [
          {
            required: true,
            message: '分账规则不可为空',
            type: 'string',
            trigger: 'change'
          }
        ]
      },
      otherSettingInfoRequired: {},
      portOrg: -1,
      billStsList: [],
      // courseorgId: '', // 课程提供方的orgid
      requiredTag: true // false为必填分账规则，true为不展示分账规则
    };
  },
  computed: {
    otherSettingInfo: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    } // 课程信息
  },
  watch: {
    courseTypeKind(newVal) {
      if (newVal) {
        // 分账规则
        console.log('课程提供方', this.courseId, this.schoolId);
        this.getLedgerRules();
        // this.getCourseDetail();
      }
    },
    schoolId: {
      immediate: true,
      handler(newVal, oldVal) {
        console.log('编辑进来的====', newVal, '学校id');
        if (newVal) {
          //     this.getRuleTag();
        }
      }
    }
  },
  created() {
    // 学校的，学校id有的
    this.portOrg = Number(localStorage.getItem('portOrg'));
    this.dealFormRequire();
  },
  mounted() {
    this.$refs.otherSettingInfo.validateField('classroomState');
    this.AddCommodityInstance.findRuleRequireNewCourse(
      this,
      'otherSettingInfo',
      '其他设置'
    );
  },
  methods: {
    getFormValidate(prop, status, error) {
      this.otherSettingInfoRequired[prop].status = status;
      this.AddCommodityInstance.findRuleRequireNewCourse(
        this,
        'otherSettingInfo',
        '其他设置'
      );
    },
    dealFormRequire() {
      this.otherSettingInfoRequired = {};
      Object.keys(this.otherSettingInfoRule).forEach((item) => {
        this.otherSettingInfoRequired[item] = {
          require: !!this.otherSettingInfoRule[item][0].required,
          status: false
        };
      });
    },
    // 校验表单
    checkForm() {
      //   this.requiredTag ? this.otherSettingInfo.itemId = '0' : '';
      this.$refs.otherSettingInfo.validate();
    },
    async getRuleTag() {
      const params = {
        schoolId: this.schoolId
      };
      const res = await common.getGoodsRuleIsRequiredApi(params);
      if (res.status === 200) {
        console.log(res.message);
        // this.otherSettingInfo.itemId = '';
        this.requiredTag = res.message ? JSON.parse(res.message) : false;

        // this.otherSettingInfoRule.itemId[0].required = !this.requiredTag;
        if (this.requiredTag) {
          this.otherSettingInfoRule = {
            classroomState: [
              {
                required: true,
                message: '请选择发布后是否上架',
                type: 'number',
                trigger: 'change'
              }
            ]
          };
        } else {
          this.otherSettingInfoRule = {
            classroomState: [
              {
                required: true,
                message: '请选择发布后是否上架',
                type: 'number',
                trigger: 'change'
              }
            ],
            itemId: [
              {
                required: true,
                message: '分账规则不可为空',
                type: 'string',
                trigger: 'change'
              }
            ]
          };
        }
        // this.dealFormRequire();
        // this.dealFormRequire();
        this.$nextTick(() => {
          this.$refs.otherSettingInfo.validateField('classroomState');
          this.requiredTag ? '' : this.$refs.otherSettingInfo.validateField('itemId');
        });
        this.dealFormRequire();
      }
    },
    // async getCourseDetail() {
    //   const res = await courseCenterApi.getCourseDetail({
    //     courseId: this.courseId
    //   });
    //   if (res.status === 200) {
    //     this.courseorgId = res.message.orgId;
    //     this.$emit('on-courseDetail', this.courseorgId)
    //     this.getLedgerRules();
    //   }
    // },
    // 获取结算分账规则
    async getLedgerRules() {
      console.log('itemType = 1')
      const params = {
        itemType: 1,
        courseTypeKind: this.courseTypeKind,
        schoolId: this.schoolId,
        orgId: this.courseOrgId,
        offerOrgId: this.courseOrgId,
      };
      const getListApi = this.exsitOrder
        ? courseCenterApi.getListByCondition
        : courseCenterApi.getListByTypeAndOrgIdAndSchId;
      const res = await getListApi(params);
      if (res.status === 200) {
        this.billStsList = res.message;
        if (this.billStsList.length == 1) {
          this.otherSettingInfo.itemId = this.billStsList[0].itemId;
          // this.otherSettingInfoRule.itemId[0].required = false;
        }
      }
    },
    hanldCourse() {
      if (!this.courseTypeKind) {
        this.$Message.error('请先选择课程分类！');
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
